// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dd9a0d0c","396":"94325c68","455":"487fbfd7","977":"6af9ea48"}[chunkId] + ".chunk.js";
};